import React from "react";
import Select from "react-select";

interface ColorOption {
  value: string;
  label: string;
  color: string;
}

// Colores predefinidos compatibles con texto negro
const colorOptions: ColorOption[] = [
  { value: "#D4F1D4", label: "Verde claro", color: "#D4F1D4" },
  { value: "#D4E9FB", label: "Azul claro", color: "#D4E9FB" },
  { value: "#FFE4CC", label: "Naranja claro", color: "#FFE4CC" },
  { value: "#EDD4ED", label: "Rosa claro", color: "#EDD4ED" },
  { value: "#FFF9CC", label: "Amarillo claro", color: "#FFF9CC" },
  { value: "#E4D4FF", label: "Lila claro", color: "#E4D4FF" },
  { value: "#D4FFED", label: "Menta claro", color: "#D4FFED" },
  { value: "#FFD4E4", label: "Coral claro", color: "#FFD4E4" },
  { value: "#EDEDC4", label: "Beige claro", color: "#EDEDC4" },
  { value: "#D4F1FF", label: "Celeste claro", color: "#D4F1FF" },
];

const ColorSelector: React.FC<any> = ({
  value,
  onChange,
  placeholder,
  required,
}) => {
  const selectedOption =
    colorOptions.find((option) => option.value === value) || null;

  const formatOptionLabel = (option: ColorOption) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div
        style={{
          width: "20px",
          height: "20px",
          backgroundColor: option.color,
          border: "1px solid #ccc",
          borderRadius: "3px",
          marginRight: "10px",
        }}
      />
      <span>{option.label}</span>
    </div>
  );

  return (
    <Select
      value={selectedOption}
      onChange={(selectedOption) => {
        onChange(selectedOption ? selectedOption.value : null);
      }}
      options={colorOptions}
      placeholder={placeholder || "Seleccionar color..."}
      formatOptionLabel={formatOptionLabel}
      isClearable
      required={required}
      noOptionsMessage={() => "No hay colores disponibles"}
    />
  );
};

export default ColorSelector;
